import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/components/ui/sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/blocks/clickables/ShareButton.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/library/blocks/images/NextImage.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/blocks/images/NextImageV2.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/market/instrument/components/InstrumentFollowButton.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/library/entities/market/instrument/components/InstrumentNavigation.jsx");
